import { getDefaultExportFromCjs as r } from "./_commonjsHelpers.js";
import { __require as o } from "../node_modules/.pnpm/@patternfly_react-tokens@6.2.2/node_modules/@patternfly/react-tokens/dist/js/t_global_breakpoint_xl.js";
var t = /* @__PURE__ */ o();
const l = /* @__PURE__ */ r(t);
export {
  l as default
};
